import ReactGA from 'react-ga4'

const initializeGA = (GA_ID) => {
  ReactGA.initialize(GA_ID)
}

const trackLoadAnAuthenticatedPage = (action, label) => {
  // Send GA4 Event
  ReactGA.event({
    category: 'User',
    action,
    label,
  })
}

export { initializeGA, trackLoadAnAuthenticatedPage }
